<template>
    <!-- Form -->
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row mb-2" v-for="(item, index) in mutableList" :key="index">
                    <div class="col-auto">
                        <b-form-select :options="dayOfWeeks" v-model="item.dayOfWeek"></b-form-select>
                    </div>

                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <b-select v-model="item.startHour" :options="hours"></b-select>
                            </div>
                            <div class="col">
                                <b-form-select v-model="item.startMinute" :options="minutes"></b-form-select>
                            </div>
                            <div class="col-auto text-center">-</div>
                            <div class="col">
                                <b-select v-model="item.endHour" :options="hours"></b-select>
                            </div>
                            <div class="col">
                                <b-form-select v-model="item.endMinute" :options="minutes"></b-form-select>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn-white" @click="add(index)">
                            <i class="fe fe-plus"></i>
                        </button>
                        <button class="btn btn-white ml-2" @click="remove(index)" :disabled="index==0">
                            <i class="fe fe-x"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    props: {
        items: Array
    },
    data() {
        return {
            mutableList: this.items,
            minutes: ['00', 15, 30, 45],
            hours: [...Array(24).keys()],
            dayOfWeeks: [
                { value: 'monday', text: this.$t('Monday') },
                { value: 'tuesday', text: this.$t('Tuesday') },
                { value: 'wednesday', text: this.$t('Wednesday') },
                { value: 'thursday', text: this.$t('Thursday') },
                { value: 'friday', text: this.$t('Friday') },
                { value: 'saturday', text: this.$t('Saturday') },
                { value: 'sunday', text: this.$t('Sunday') },
            ],
        }
    },
    watch: {
        mutableList() {
            this.$emit('update:items', this.mutableList);
        },
        items() {
            this.mutableList = this.items;
        },
    },

    mounted() {
        if (!this.items || this.items.length == 0) {
            this.mutableList = [];
            this.add(-1);
        }
    },
    methods: {
        remove(index) {
            this.mutableList.splice(index, 1);
        },



        byindex(index) {
            let item = this.mutableList[index];
            if (!item) return -2;
            let itemIndex = this.dayOfWeeks.findIndex(row => row.value === item.dayOfWeek);
            return itemIndex;
        },


        add(index) {

            let dayOfWeek, dayOfWeeks;
            let current = this.byindex(index);
            let next = this.byindex(index + 1);
            let itemIndex = current;


            if (next < 0) {
                itemIndex++;
            }

            dayOfWeeks = this.dayOfWeeks[itemIndex];
            if (dayOfWeeks)
                dayOfWeek = dayOfWeeks.value;


            this.mutableList.splice(index + 1, 0, {
                dayOfWeek: dayOfWeek || 'monday',
                startHour: 9,
                startMinute: "00",
                endHour: 18,
                endMinute: "00"
            });
        }
    }
}
</script>
